/**
 * VisualIndicators Component
 * EXACT PORT dari ModelViewerBACKUP.jsx
 * 
 * Visual feedback overlays:
 * - Video buffering indicator (line 8953-8982)
 * - Locked aspect ratio badge (line 8880-8913)
 * 
 * @param {Object} props - Indicator states
 */

import React from 'react'

export default function VisualIndicators({
  isReady,
  viewportReady,
  // Video buffering
  videosBuffering = 0,
  // Locked aspect ratio
  lockAspectRatio,
  exportWidth,
  exportHeight,
}) {
  return (
    <>
      {/* Video Buffering Indicator */}
      {isReady && videosBuffering > 0 && (
        <div
          style={{
            position: 'absolute',
            top: '20px',
            left: '50%',
            transform: 'translateX(-50%)',
            padding: '12px 20px',
            background:
              'linear-gradient(135deg, rgba(251, 191, 36, 0.9), rgba(245, 158, 11, 0.9))',
            backdropFilter: 'blur(20px)',
            WebkitBackdropFilter: 'blur(20px)',
            color: '#fff',
            border: '1px solid rgba(255, 255, 255, 0.3)',
            borderRadius: '12px',
            fontSize: '13px',
            fontWeight: 600,
            fontFamily: 'system-ui, -apple-system, sans-serif',
            zIndex: 100,
            boxShadow: '0 8px 24px rgba(251, 191, 36, 0.25)',
            animation: 'pulse 1.5s ease-in-out infinite',
          }}
        >
          🎬 Buffering {videosBuffering} video texture
          {videosBuffering > 1 ? 's' : ''}...
        </div>
      )}

      {/* Locked Aspect Ratio Badge */}
      {lockAspectRatio && viewportReady && (
        <div
          style={{
            position: 'absolute',
            top: viewportReady ? '70px' : '20px',
            left: '50%',
            transform: 'translateX(-50%)',
            padding: '8px 14px',
            background:
              'linear-gradient(135deg, rgba(59, 130, 246, 0.75), rgba(37, 99, 235, 0.82))',
            backdropFilter: 'blur(20px) saturate(190%)',
            WebkitBackdropFilter: 'blur(20px) saturate(190%)',
            color: '#fff',
            border: '0.5px solid rgba(255, 255, 255, 0.22)',
            borderTop: '0.5px solid rgba(255, 255, 255, 0.3)',
            borderRadius: '10px',
            fontSize: '11px',
            fontWeight: 600,
            fontFamily: 'system-ui, -apple-system, sans-serif',
            zIndex: 10,
            boxShadow:
              '0 4px 12px rgba(0, 0, 0, 0.18), 0 8px 24px rgba(0, 0, 0, 0.12)',
            animation: 'fadeIn 0.4s ease-out 0.4s forwards',
            opacity: 0,
          }}
        >
          🔒 {exportWidth}×{exportHeight} (
          {(exportWidth / exportHeight).toFixed(2)}:1)
        </div>
      )}
    </>
  )
}

